import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { changepasswordfun, profile } from '../../../components/Apis';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import EditProfile from './EditProfile';

const Profile = () => {
  const [profilee, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editForm, seteditForm] = useState(false);
  const getProfile = async () => {
    Swal.fire({
      title: 'Loading...',
      text: 'Please wait while we load the data.',
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await profile();
      setProfile(response);
      setLoading(false);
      Swal.close();
    } catch (error) {
      console.error(error.message);
      setLoading(false);
      Swal.close();
    }
  };
  
  useEffect(() => {


    getProfile();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      Swal.fire("New password and confirmation don't match");
    } else {
      const changepassword = {
        old_password: currentPassword,
        new_password: newPassword,
        new_password_confirmation: confirmPassword,
      };
      const res = await changepasswordfun(changepassword);

      if (res.message === 'Password changed successfully.') {
        Swal.fire('Password changed successfully');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setShowForm(false);
      } else if (res.message === 'Old password is incorrect.') {
        Swal.fire('Old password is incorrect');
      }
    }
  };

  return (
    <Box sx={{ padding: '20px', position: "relative", height: "100vh", backgroundColor: "var(--seco-col)" }} dir="ltr">
      {editForm === false ? (
        <>
          <Typography variant="body2" sx={{ color: 'black',fontSize:"24px",fontWeight:"600" }}>
            Profile
          </Typography>
          <Box
            sx={{
              backgroundColor: '#fff',
              padding: '20px',
              display: 'flex',
              alignItems: 'center',
              border: '1px solid #F3EBE8',
              backgroundColor: "#FFF",
              marginBottom: "1rem",
              borderRadius: "12px 12px 0px 0px !important",
              marginTop:"2rem",
            }}
          >
            <img
              src={profilee.image}
              alt="Profile"
              style={{
                width: '100px',
                height: '100px',
                borderRadius: '50%',
                marginRight: '20px',
              }}
            />
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>
                {profilee.first_name} {profilee.last_name}
              </Typography>
              <Typography variant="body2" sx={{ color: '#777' }}>
                Owner
              </Typography>
            </Box>
          </Box>

          <Card
            sx={{
              width: '100%',
              margin: 'auto',
              borderRadius: '10px',
              boxShadow: 3,
              overflow: 'hidden',
              borderRadius: "0px 0px 12px 12px !important",
              backgroundColor:"#fff"
            }}
          >


            {/* Personal Info Section */}
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '15px' }}>
                Personal Info
              </Typography>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', width: '30%', borderBottom: 'none',paddingBottom:"5px" }}>
                        First Name
                      </TableCell>
                      <TableCell sx={{ borderBottom: 'none' ,paddingBottom:"5px"}}>{profilee.first_name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', borderBottom: 'none',paddingBottom:"5px" }}>Last Name</TableCell>
                      <TableCell sx={{ borderBottom: 'none' ,paddingBottom:"5px"}}>{profilee.last_name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', borderBottom: 'none' ,paddingBottom:"5px"}}>Email Address</TableCell>
                      <TableCell sx={{ borderBottom: 'none',paddingBottom:"5px" }}>{profilee.email}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', borderBottom: 'none',paddingBottom:"5px" }}>Phone</TableCell>
                      <TableCell sx={{ borderBottom: 'none' ,paddingBottom:"5px"}}>{profilee.phone_number}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', borderBottom: 'none',paddingBottom:"5px" }}>Address</TableCell>
                      <TableCell sx={{ borderBottom: 'none',paddingBottom:"5px" }}>{profilee.address}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', borderBottom: 'none',paddingBottom:"5px" }}>Country</TableCell>
                      <TableCell sx={{ borderBottom: 'none',paddingBottom:"5px" }}>{profilee.country_name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', borderBottom: 'none',paddingBottom:"10px" }}>City/State</TableCell>
                      <TableCell sx={{ borderBottom: 'none',paddingBottom:"10px" }}>{profilee.city_name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', borderBottom: 'none' }}>Identity Image</TableCell>
                      <TableCell sx={{ borderBottom: 'none',padding:"0px" }}>
                        <img src={profilee.identity_images} alt="Identity" style={{ width: '200px', height: '100px' }} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>

            {/* Footer Section */}
            <Box
              sx={{
                padding: '10px 20px',
                textAlign: 'right',
                backgroundColor: '#f8f9fa',
                borderTop: '2px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Button
                variant="outlined"
                onClick={() => setShowForm(!showForm)}
                sx={{
                  color: '#fff',
                  backgroundColor: 'var(--pri-col)',
                  borderColor: 'var(--pri-col)',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'var(--pri-col)', borderColor: 'var(--pri-col)' },
                }}
              >
                Change Password
              </Button>
              <Button
                variant="outlined"
                sx={{
                  color: '#fff',
                  zIndex:"5",
                  backgroundColor: 'var(--pri-col)',
                  borderColor: 'var(--pri-col)',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'var(--pri-col)', borderColor: 'var(--pri-col)' },
                }}
                onClick={() => seteditForm(!editForm)}
              >
                Edit Profile
              </Button>
            </Box>
          </Card>



          {showForm && (
            <Box
              onClick={() => setShowForm(false)}
              sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 1000,
              }}
            >
              <Box
                onClick={(e) => e.stopPropagation()}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  padding: '20px',
                  maxWidth: '40%',
                  margin: '20px auto',
                  direction: 'ltr',
                  backgroundColor: '#fff',
                  borderRadius: '10px',
                  boxShadow: 3,
                  overflow: 'hidden',
                }}
              >
                <Typography variant="h5" gutterBottom>
                  Change Password
                </Typography>
                <form onSubmit={handleSubmit}>
                  <TextField
                    label="Current Password"
                    type={showCurrentPassword ? 'text' : 'password'}
                    fullWidth
                    margin="normal"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                          >
                            {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="New Password"
                    type={showNewPassword ? 'text' : 'password'}
                    fullWidth
                    margin="normal"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowNewPassword(!showNewPassword)}
                          >
                            {showNewPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="Confirm New Password"
                    type={showConfirmPassword ? 'text' : 'password'}
                    fullWidth
                    margin="normal"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          >
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      width: '100%',
                      marginTop: '20px',
                      backgroundColor: 'var(--pri-col)',
                      '&:hover': {
                        backgroundColor: 'var(--pri-col)',
                      },
                    }}
                  >
                    Change Password
                  </Button>
                </form>
              </Box>
            </Box>
          )}
        </>
      ) : (
        <EditProfile profile={profilee} editForm={seteditForm} getProfile={getProfile} />
      )}

      <img src="../../assets/Bask 01-04 1.png" style={{ width: "150px", height: "150px", position: "absolute", bottom: "0px", right: "0pc" }} />
    </Box>


  );
};

export default Profile;
